import { FC } from "react";
import DefaultLayout from "ui-modules/components/Layout/DefaultLayout";
import arrowLeft from "@iconify/icons-mdi/arrow-left";
import { useHistory } from "react-router";
import ContainerFluid from "ui-modules/components/Layout/ContainerFluid";
import rest from "../utils/rest";
import { localRemoveItem, sessionRemoveItem } from "../utils/storage";
import accountOutline from "@iconify/icons-mdi/account-outline";
import Img from "ui-modules/components/Image/Img";
import zitelLogo from "../assets/images/ztel.png";
import useGlobal from "ui-modules/commons/hooks/use-global";

type EmployeeLayoutTypes = {
  title?: string;
  back?: boolean;
};

const EmployeeLayout: FC<EmployeeLayoutTypes> = (props) => {
  const { children, title = "سامانه کارشناسان زی‌تل", back = false } = props;

  const history = useHistory();

  const { me = {} } = useGlobal()?.global || {};

  const handleExit = () => {
    rest
      .delete(`${process.env.REACT_APP_AUTH_SERVICE}/auth/revoke`)
      .then(() => {
        localRemoveItem();
        sessionRemoveItem();
        history.replace("/auth/login");
      })
      .catch(() => {
        localRemoveItem();
        sessionRemoveItem();
        history.replace("/auth/login");
      });
  };

  const handleOpenWebSite = () => window.open("https://www.zi-tel.com/");

  const actionItems = back ? [{ icon: arrowLeft, showOnMobile: true, onClick: () => history.goBack() }] : [];

  return (
    <DefaultLayout
      appBar={{
        actionItems,
        topAppBarTitle: [{ title: "وبسایت", align: "start", onClick: handleOpenWebSite, showOnMobile: true }],
        menu: {
          title: me?.party?.fullName || "",
          icon: accountOutline,
          hideTitleInMobile: true,
          onlyInMobile: [
            {
              title: me?.party?.fullName || "",
              divider: true,
            },
          ],
          items: [{ title: "خروج", onClick: handleExit }],
        },
      }}
      sideBar={{
        headerIcon: <Img alt="Logo" src={zitelLogo} customCSS={"width: 15px;"} />,
        headerTitle: title,
      }}
    >
      <ContainerFluid>{children}</ContainerFluid>
    </DefaultLayout>
  );
};

export default EmployeeLayout;
